import React from "react";

/**
 * Vibe for Success custom logo mark.
 * Geometric stacked rounded square + accent dot, gradient-filled.
 */
export const Logo = ({ size = 32, withWordmark = true, className = "" }) => {
    const gradId = "vfs-logo-grad";
    return (
        <div
            className={`flex items-center gap-2.5 ${className}`}
            data-testid="brand-logo"
        >
            <svg
                width={size}
                height={size}
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <defs>
                    <linearGradient
                        id={gradId}
                        x1="0"
                        y1="0"
                        x2="40"
                        y2="40"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0%" stopColor="#EC4899" />
                        <stop offset="50%" stopColor="#8B5CF6" />
                        <stop offset="100%" stopColor="#3B82F6" />
                    </linearGradient>
                </defs>
                {/* Back square */}
                <rect
                    x="4"
                    y="10"
                    width="24"
                    height="24"
                    rx="6"
                    fill={`url(#${gradId})`}
                    opacity="0.5"
                />
                {/* Front square */}
                <rect
                    x="12"
                    y="4"
                    width="24"
                    height="24"
                    rx="6"
                    fill={`url(#${gradId})`}
                />
                {/* Accent dot */}
                <circle cx="32" cy="32" r="3.5" fill="#FBBF24" />
            </svg>
            {withWordmark && (
                <span
                    className="font-semibold tracking-tight text-[1.05rem]"
                    style={{
                        fontFamily: "'Space Grotesk', sans-serif",
                        color: "var(--text-primary)",
                    }}
                >
                    Vibe for Success
                </span>
            )}
        </div>
    );
};

export default Logo;
